import "../scss/style.scss";
import "./home.js";
import 'lity';
import "jquery-match-height";

jQuery(function ($) {

	// smooth scroll
	$(function () {
		$('a[href^="#"]').click(function () {
			var headerH = 0;
			var href = $(this).attr("href");
			var target = $(href == "#" || href == "" ? "body" : href);
			var position = target.offset().top - headerH;
			$("html, body").animate({ scrollTop: position }, 800, "swing");
			return false;
		});
	});

	// search form
	$(function () {
		$('.header__search__btn').on('click', function () {
			if (window.matchMedia('(min-width: 769px)').matches) {
				var browserW = $(window).width();
				var logo = $('.header__logo01').width();
				var width = ((browserW - logo - 400) / 2);
				var widthInput = width - 70;
			} else {
				var browserW = $(window).width();
				var width = browserW - 65;
				var widthInput = width - 70;
			}

			$('.header__search').toggleClass('open');
			$('.header__search').width(width);
			$('.header__search input').width(widthInput);
		});

		$('.header__search__back').on('click', function () {
			$('.header__search').removeClass('open');
		});
	});

	// pagetop
	$(function(){
		$(window).scroll(function () {
			if($(this).scrollTop() >= 500) {
				$('.toTop').fadeIn();
				$('.js-scroll').fadeOut();
			} else {
				$('.toTop').fadeOut();
				$('.js-scroll').fadeIn();
			}
			var scrollHeight = $(document).height();
			var scrollPosition = $(window).height() + $(window).scrollTop();
			var footerHeight = $(".js-footer").innerHeight();
			if ( scrollHeight - scrollPosition  <= footerHeight - 45 ) {
				$(".js-pagetop").addClass('is-stop');
			} else {
				$(".js-pagetop").removeClass('is-stop');
			}
		});
	});

	$(document).ready(function () {
		$('.navBtn').on('click', function () {
			if ($('#nav').hasClass('close')) {
				$("#nav").removeClass('close');
				$(this).removeClass('close');
				$('.header__search').removeClass('close');
				$('.header__search').removeClass('open');
			} else {
				$("#nav").addClass('close');
				$(this).addClass('close');
				$('.header__search').addClass('close');
			}
		});
		$('.header__navList li a,.header__navList__closeBtn, .header__navBg').on('click', function () {
      console.log('click');
			$("#nav").removeClass('close');
			$('.navBtn.close').removeClass('close');
			$('.header__search').removeClass('close');
		});
	});

	// header fixed
	$(window).on("scroll", function(){
		$(".js-header").css("left", -$(window).scrollLeft());
	});
	$(function(){
		var headerH = $('.js-header').outerHeight();
		$('body').css('padding-top', headerH + 'px');
	});

	//スクロールされたらフェードイン & アップ
	$(window).scroll(function () {
		$('.fade-in,.fade-in-left,.fade-in-right,.fade-up').each(function () {
			var elemPos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > elemPos - windowHeight + windowHeight / 7) {
				$(this).addClass('scrollin');
			}
			// else {
			// 	$(this).removeClass('scrollin');
			// }
		});
	});

  $(function() {
    $('.js-matchHeight').matchHeight();
	});

});